function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Manage-Credit-Cards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "00:-Table-of-Contents",
  transform: "translate(-724.000000, -628.000000)"
}, React.createElement("g", {
  id: "icon/edit",
  transform: "translate(724.624344, 628.000000)"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("polygon", {
  id: "Rectangle-Copy-5",
  fill: "#444B68",
  points: "9.84632445 2.83628712 13.1284326 6.11839527 4.92316223 14.3236656 1.64105408 11.0415575"
}), React.createElement("path", {
  d: "M12.6826116,1.41421356 L12.0810651,2.01576009 L13.9489596,3.88365467 L14.5505062,3.28210815 L12.6826116,1.41421356 Z",
  id: "Rectangle-Copy-6",
  stroke: "#444B68",
  strokeWidth: 2,
  fill: "#FFFFFF"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-8",
  fill: "#444B68",
  points: "0.820527038 11.8620845 4.10263519 15.1441927 3.01358938e-12 15.9647197"
})))));

function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["svgRef", "title", "titleId"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? React.createElement("title", {
    id: titleId
  }, "icon/edit") : title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.68ae0695.svg";
export { ForwardRef as ReactComponent };